// Reads a JSON value from localStorage, returning `fallback` when the key is missing or does not hold valid JSON.
// A value that cannot be parsed (e.g. the string "undefined" left by `setItem(key, JSON.stringify(undefined))`)
// is removed, so callers that cache on the key's presence fetch it again instead of failing on every read.
export const getStoredJSON = (key, fallback = null) => {
  const raw = window.localStorage.getItem(key);
  if (raw === null) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    window.localStorage.removeItem(key);
    return fallback;
  }
};

// Stores `value` as JSON; an undefined value removes the key rather than storing the string "undefined".
export const setStoredJSON = (key, value) => {
  if (value === undefined) {
    window.localStorage.removeItem(key);
    return;
  }
  window.localStorage.setItem(key, JSON.stringify(value));
};
